import { Invoice } from '../model/invoice';
export class InvoiceBuilder {
    static buildInvoice(data) {
        let invoice = new Invoice();
        invoice.id = data.invoice_id;
        invoice.date = new Date(data.date);
        invoice.amount = data.amount;
        invoice.profileId = data.profile_id;
        invoice.profileName = data.profile_name;
        invoice.costCenterId = data.cost_center_id;
        invoice.costCenterName = data.cost_center_name;
        invoice.pdfUrl = data.pdf_url;
        invoice.invoice_number = data.invoice_number;
        invoice.is_company = data.is_company;
        invoice.nif = data.nif;
        invoice.type = data.type;
        return invoice;
    }
}
//# sourceMappingURL=invoice-builder.js.map